import { ArchiveProjectMenuItem } from "./archive-project-menu-item"
import { ProjectContextMenu } from "./project-context-menu"
import { ProjectEditMenuItem } from "./project-edit-menu-item"

ProjectContextMenu.plug(<ProjectEditMenuItem priority={10} />)
ProjectContextMenu.plug(<ArchiveProjectMenuItem priority={20} />)
